export function headerActions() {
    const $body = $("body");
    const $headerBanner = $(".header-announcement-banner");
    const $headerBannerClose = $headerBanner.find(".header-announcement-close");
    const $header = $(".header");
    const $menuOpener = $(".menu-opener");
    const $headerTabs = $header.find(".main-nav-tabs");
    const $backLink = $header.find(".back-link");
    const $mainNavList = $header.find(".main-nav-list");
    const hasDrop = $mainNavList.find(".item-has-children");
    const mobileTabOpener = $mainNavList.find(".mobile-tab-opener");
    let lastScroll = 0;
    $menuOpener.on("click", function () {
        $body.toggleClass("main-menu-open");
        $body.removeClass("menu-drop-open");
        hasDrop.removeClass("show-drop");
        $headerTabs.find(".active").removeClass("active").next().slideUp(300);
        $headerBanner.slideUp(750);
        setTimeout(function () {
            if (!$body.hasClass("main-menu-open")) {
                if (!$headerBanner.hasClass("banner-hide")) {
                    $headerBanner.slideDown(500);
                }
            }
        }, 300);
    });
    hasDrop.on("click", ">button", function (e) {        
        if (window.innerWidth < 1200 || $body.hasClass("touch")) {            
            let $this = $(this);
            if (!$this.parent().hasClass("show-drop")) {
                hasDrop.removeClass("show-drop");
                $this.parent().addClass("show-drop");
                $body.addClass("menu-drop-open");
            } else {
                $this.parent().removeClass("show-drop");
                $body.removeClass("menu-drop-open");
            }
        }
    });
    $backLink.on("click", function () {
        hasDrop.removeClass("show-drop");
        $body.removeClass("menu-drop-open");
    });
    mobileTabOpener.on("click", function () {
        let $this = $(this);
        if ($this.parent().hasClass("active")) {
            $this.parent().removeClass("active").next().slideUp(300);
        } else {
            $this.parent().addClass("active").next().slideDown(300);
        }
    });
    $headerTabs.find(".item a").on("click", function (e) {

        if (window.innerWidth > 1199) {
            e.preventDefault();
            let $this = $(this);
            if (!$this.parent().hasClass("active")) {
                let index = $(this).parent().index();
                $this.parent().parent().find(".item.active").removeClass("active");
                $this.parent().addClass("active");
                $this.parents(".custom-dropdown").find(".menu-tab-info").removeClass("active");
                $this.parents(".custom-dropdown").find(".column").each(function () {
                    $(this).find(".menu-tab-info").eq(index).addClass("active");
                });
            }
        }
    });

    $headerBannerClose.on("click", function (e) {
        e.preventDefault();
        let expiry = new Date();
        expiry.setTime(expiry.getTime() + (24 * 60 * 60 * 1000));
        document.cookie = "announcementBanner=yes; path=/; expires=" + expiry.toGMTString();
        $headerBanner.slideUp(500);
        setTimeout(function () {
            $headerBanner.remove();
            $body.addClass("banner-hide");
        }, 500);
    });


    function forMobileClones() {
        if (window.innerWidth < 1200) {
            if (!$(".main-nav-tabs .menu-tab-info").length) {
                hasDrop.each(function (index, it) {
                    let tabNavItem = $(it).find(".main-nav-tabs .item");
                    tabNavItem.each(function (i, el) {
                        let clone = tabNavItem.parents(".column").next().find(".menu-tab-info").eq(i).clone();
                        $(el).after(clone);
                    });
                });
            }
        } else {
            hasDrop.find(".main-nav-tabs .menu-tab-info").remove();
        }

    }

    function stickyHeader() {
        let currentScroll = window.pageYOffset;
        if (currentScroll === 0 || currentScroll < 0) {
            $body.removeClass("up");
            $body.removeClass("sticky");
            if ($headerBanner.hasClass("banner-hide") && !$body.hasClass("main-menu-open")) {
                $headerBanner.removeClass("banner-hide").slideDown(500);
            }
            return;
        }
        if (currentScroll > 0) {
            $body.addClass("sticky");
            if (!$headerBanner.hasClass("banner-hide")) {
                $headerBanner.addClass("banner-hide").slideUp(500);
            }
        } else {
            $body.removeClass("sticky");
        }
        if (currentScroll > lastScroll + 1 && !$body.hasClass("down")) {
            $body.removeClass("up").addClass("down");
        } else if (currentScroll < lastScroll && $body.hasClass("down")) {
            $body.removeClass("down").addClass("up");
        }
        lastScroll = currentScroll;
    }

    function menuTabsDesktop() {
        if (window.innerWidth >= 1200) {
            $headerTabs.each(function () {
                let $this = $(this);
                $this.find(".item").removeClass("active");
                $this.find(".item:first-child").addClass("active");
                $this.parents(".custom-dropdown").find(".column").each(function () {
                    $(this).find(".menu-tab-info").removeClass("active");
                    $(this).find(".menu-tab-info:first-child").addClass("active");
                });
            });
        }
    }

    window.addEventListener("load", () => {
        stickyHeader();
        menuTabsDesktop();
        forMobileClones();
    });
    window.addEventListener("scroll", () => {
        stickyHeader();
    });
    window.addEventListener("resize", () => {
        menuTabsDesktop();
        forMobileClones();
    });

    if (document.cookie.indexOf("announcementBanner=") >= 0) {
        $body.addClass("banner-hide")
        $headerBanner.remove();
    } else {
        setTimeout(function () {
            if (!$headerBanner.hasClass("banner-hide")) {
                $headerBanner.slideDown(500);
            }
        }, 300);
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/headerActions.js